"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const PopoverContext = react_1.createContext({
    inPopover: true,
    isOpen: false,
    closeOnBtnClick: false,
    onClose: () => { },
});
PopoverContext.displayName = 'PopoverContext';
exports.default = PopoverContext;
